import React from "react";
import ViewAllButton from "../../commons/ViewAllButton";
import CartPriceItem from "../../commons/CartPriceItem";
import CustomShippingFeeNotAdded from "../../commons/CustomShippingFeeNotAdded";
import { useNavigate } from "react-router-dom";
import useUser from "../../hooks/useUser";
import { saveIntendedRoute } from "../../local_store/intendedRouteLocalStore";
import { useCart } from "../../contexts/CartContext";

function CartSummary({ cartItemsData, isLoading }) {
  const navigate = useNavigate();
  const { user } = useUser();
  const { cart } = useCart();

  // Calculate subtotal for local cart
  const calculateSubTotal = () => {
    if (user) {
      return cartItemsData?.subTotalPrice || 0; // Use server subtotal for logged-in users
    } else {
      // Calculate subtotal for local cart
      return cart.reduce((total, item) => {
        const price = item.product.priceAfterDiscount || item.product.price;
        const installationPrice = item.addInstallationPrice
          ? item.product.installationPrice || 0
          : 0;
        return total + (price  * item.quantity)  + installationPrice;
      }, 0);
    }
  };

  const subTotalPrice = calculateSubTotal();

  const handleCheckout = () => {
    if (!user) {
      // User is not logged in
      saveIntendedRoute("/my-cart/checkout");
      navigate("/auth/login");
      return;
    }

    navigate("/my-cart/checkout");
  };
  return (
    <>
      {!isLoading && (
        <div className="p-5 rounded-lg bg-white shadow-md h-full">
          <div className="mb-8">
            <div className="font-[600] text-[20px] max-lg:text-[17px] max-md:text-[14px]">
              Cart Summary
            </div>
          </div>

          <hr />

          <CartPriceItem
            title="Sub Total"
            price={`${subTotalPrice ?? 0}`}
          />

          <hr />

          <CustomShippingFeeNotAdded />
          <hr />

          {/* <CartPriceItem
            title="Total"
            price={`${cartItemsData?.totalPrice ?? 0}`}
          /> */}

          <div className="mt-8">
            <ViewAllButton
              className="hover:text-white w-full text-center py-3 items-center hover:bg-[#FF9D21] text-[#FF9D21] bg-white border border-orange-400"
              text="Checkout"
              onClick={handleCheckout}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default CartSummary;
